/* Style My Wall - "View in a room" + "See it on your wall" (AR). 2026-10-03.
 * Reads the shopper's current size / frame / border from the product form and the
 * frame overlay the gallery already draws (preload-frame.liquid), so it always
 * matches the gallery. Writes only its own modal (appended to <body>).
 * Room scenes: assets/smw-room-*.webp, rendered straight-on so the wall has one
 * uniform scale (widthCm = wall width shown across the image, horizonCm = wall
 * height at the image's vertical centre). AR: a GLB is built in the browser from
 * the same composite and shown with Google's <model-viewer> (WebXR on Android,
 * Quick Look on iPhone, wall placement, fixed true scale). Desktop gets a QR code.
 */
(function () {
  if (window.__smwRoomView) return;
  window.__smwRoomView = true;

  var cfgEl = document.getElementById('smw-rv-config');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  var SIZE_CM = { A4: [21, 30], A3: [30, 42], A2: [42, 60], A1: [59, 84], B1: [70, 100], A0: [84, 119], B0: [100, 141] };
  var FALLBACK_COLOUR = {
    'Natural Timber': '#b98a5a', 'White Frame': '#f1f0ec', 'Black Frame': '#1d1c1b',
    'Timber Canvas Floating Frame': '#a57a4e', 'Black Canvas Floating Frame': '#1d1c1b',
    'White Canvas Floating Frame': '#efeeea', 'Gold Leaf Floating Frame': '#c9a24a', 'Silver Leaf Floating Frame': '#bdbdb8'
  };
  // Read the QR-link params now: the theme rewrites the URL to ?variant=... soon after load.
  var START = new URLSearchParams(location.search);
  var roomIdx = 0, modal = null, tab = 'room', mvLoading = null, lastGlbUrl = null, lastUsdzUrl = null;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  // Upload Your Own (product-template-digital-upload): the art is the shopper's own uploaded crop shown in
  // .left-frame-preview, its state lives in the page's global imagesState / activeImageId, and the working Add
  // to Cart is .add-to-cart-2 (it runs the print approval pop-up).
  function upFrameEl() { return q('.left-frame-preview .image-frame'); }
  function upState() {
    try { return imagesState[activeImageId] || null; } catch (e) { return null; }
  }
  function upReady() {
    var st = upState(), im = upFrameEl() && q('img', upFrameEl());
    return !!(st && st.uploaded && st.uploadedImage && im && im.getAttribute('src') === st.uploadedImage);
  }
  var UP = !!upFrameEl() && (function () { try { return typeof imagesState === 'object'; } catch (e) { return false; } })();
  function atcBtn(s) { return (UP && q('.add-to-cart-2')) || q('[data-add-to-cart]', s); }
  function atcDisabled(b) { return !b || b.disabled || b.getAttribute('aria-disabled') === 'true'; }
  function sec() { return q('.product-section:not([data-modal="true"])') || q('.product-section'); }
  function visible(el) { return !!(el && el.getClientRects().length && getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden'); }
  function parseCm(t) {
    var m = /(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*cm/i.exec(t || '');
    return m ? [parseFloat(m[1]), parseFloat(m[2])] : null;
  }
  function sizeItems(s) {
    var seen = {};
    return qa('.dropdown_list li[data-title]', s).filter(function (li) {
      var k = li.getAttribute('data-title').trim();
      if (seen[k] || !k || li.classList.contains('size-option-disabled-mi')) return false;
      seen[k] = 1;
      return getComputedStyle(li).display !== 'none';
    });
  }

  // ---------- read the current selection ----------
  function readState() {
    var s = sec();
    if (!s) return null;
    var act = q('.variant_select-product.active_seclet', s);
    var key = act ? (act.getAttribute('data-title') || '').trim() : '';
    var li = qa('.dropdown_list li[data-title]', s).filter(function (l) { return l.getAttribute('data-title').trim() === key; })[0];
    var label = li ? li.textContent.replace(/\s+/g, ' ').trim() : key;
    var cm = parseCm(label) || parseCm(act && act.textContent) || SIZE_CM[key] || null;
    var fr = q('input[name="Frame"]:checked', s);
    var bo = q('input[name="Border Options"]:checked', s);
    var slide = UP ? null : (q('.starting-slide', s) || q('.product-main-slide', s));
    var img = UP ? q('img', upFrameEl()) : slide && q('img', slide);
    var src = img ? (img.currentSrc || img.src || img.getAttribute('data-src') || '') : '';
    if (!src) src = CFG.image;
    if (/\/cdn\/shop\//.test(src)) { try { var u = new URL(src, location.href); u.searchParams.set('width', '1600'); src = u.toString(); } catch (e) {} }
    var ar = img && img.naturalWidth ? img.naturalWidth / img.naturalHeight : CFG.imageAspect || 0.707;
    // Upload page with a white border chosen on the slider (smw-white-border.js): use the bordered paper as the art.
    var wbArt = UP && window.smwWB && window.smwWB.roomArt ? window.smwWB.roomArt() : null;
    if (wbArt) src = wbArt;
    return {
      s: s, slide: slide, key: key, label: label, cm: cm,
      frame: fr ? fr.value : 'Unframed',
      border: (q('[data-border]', s) && q('[data-border]', s).getAttribute('data-border')) || (bo ? bo.value : 'No Border'),
      src: src, aspect: ar, wbArt: !!wbArt
    };
  }

  // The gallery draws the frame as a ::before PNG over the starting slide, insetting the
  // art by the slide's padding. Read both (from a hidden probe if another slide is showing).
  function frameLook(st) {
    var el = st.slide, probe = null;
    var look = { bg: '', inset: [0, 0, 0, 0], gap: '' };
    if (UP) {
      // The upload preview draws the frame PNG straight over the photo (no inset), so place the art inside the
      // moulding from the PNG geometry instead: 33 px band on the 849 x 1200 ISO frames, band + white mat = 66 px
      // with a White Border, 38 / 1254 on the square set, plus a 0.4% dark gap on floating canvas frames.
      var fe = upFrameEl(), bgi = fe ? getComputedStyle(fe, '::before').backgroundImage : 'none';
      var mm = bgi && bgi !== 'none' && /url\(["']?([^"')]+)["']?\)/.exec(bgi);
      if (!mm) return look;
      look.bg = mm[1].replace(/_\d+x\d+(?=\.(png|jpe?g|webp)(\?|$))/i, '');
      var sq = Math.abs(st.aspect - 1) < 0.03, px = !st.wbArt && /White/.test(st.border) && !/Canvas|Leaf/.test(st.frame) ? 66 : 33;
      var bx = sq ? 38 / 1254 : st.aspect < 1 ? px / 849 : px / 1200, by = sq ? 38 / 1254 : st.aspect < 1 ? px / 1200 : px / 849;
      if (/Floating/.test(st.frame)) { bx += 0.004; by += 0.004; look.gap = '#2e2c29'; }
      look.inset = [by, bx, by, bx];
      return look;
    }
    if (!el) return look;
    if (!el.classList.contains('is-selected')) {
      probe = el.cloneNode(false);
      probe.classList.add('is-selected');
      probe.removeAttribute('id');
      probe.style.cssText = 'position:absolute;left:-99999px;top:0;visibility:hidden;width:' + el.clientWidth + 'px;height:' + el.clientHeight + 'px;';
      el.parentNode.appendChild(probe);
      el = probe;
    }
    var b = getComputedStyle(el, '::before').backgroundImage;
    var cs = getComputedStyle(el);
    if (b && b !== 'none') {
      var m = /url\(["']?([^"')]+)["']?\)/.exec(b);
      look.bg = m ? m[1] : '';
      var W = el.clientWidth || 1, H = el.clientHeight || 1;
      look.inset = [parseFloat(cs.paddingTop) / H, parseFloat(cs.paddingRight) / W, parseFloat(cs.paddingBottom) / H, parseFloat(cs.paddingLeft) / W];
      var bgc = cs.backgroundColor;
      if (bgc && bgc !== 'rgba(0, 0, 0, 0)' && bgc !== 'transparent') look.gap = bgc;
    }
    if (probe) probe.remove();
    return look;
  }

  // Physical size + how to draw it.
  function model(st) {
    if (!st || !st.cm) return null;
    var a = st.cm[0], b = st.cm[1], lo = Math.min(a, b), hi = Math.max(a, b);
    var w, h;
    if (Math.abs(a - b) < 0.5) { w = h = a; }
    else if (st.aspect > 1.02) { w = hi; h = lo; }
    else { w = lo; h = hi; }
    var look = frameLook(st);
    var f = st.frame;
    var canvas = /Canvas|Leaf/.test(f);
    var framed = f !== 'Unframed' && f !== 'Stretched Canvas';
    var m = { printW: w, printH: h, outerW: w, outerH: h, look: look, framed: framed, canvas: canvas, frame: f, border: st.border, depth: framed ? 3 : canvas ? 3.8 : 0.3 };
    var ins = look.inset;
    if (framed && look.bg) {
      if (/White/.test(st.border)) {
        // The white border is printed inside the same print size, so the frame's outer size is the
        // No Border one: print + the moulding band (33 px of the 849 x 1200 ISO frame PNGs).
        var bs = 33 / 849, bl = 33 / 1200, sq = Math.abs(w - h) < 0.5;
        m.outerW = w / (1 - 2 * (sq ? 38 / 1254 : w < h ? bs : bl));
        m.outerH = h / (1 - 2 * (sq ? 38 / 1254 : w < h ? bl : bs));
      } else {
        m.outerW = w / Math.max(0.5, 1 - ins[1] - ins[3]);
        m.outerH = h / Math.max(0.5, 1 - ins[0] - ins[2]);
      }
    } else if (framed) {
      // overlay missing: draw a plain moulding 2.5 cm wide
      m.fallback = FALLBACK_COLOUR[f] || '#222';
      m.outerW = w + 5; m.outerH = h + 5;
      look.inset = [2.5 / m.outerH, 2.5 / m.outerW, 2.5 / m.outerH, 2.5 / m.outerW];
    } else if (f === 'Unframed' && /White/.test(st.border) && !st.wbArt) {
      m.paperBorder = true;
      look.inset = [0.045, 0.045 * h / w, 0.045, 0.045 * h / w];
    } else {
      look.inset = [0, 0, 0, 0];
    }
    return m;
  }

  // ---------- modal ----------
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  function build() {
    modal = el('div', 'smw-rv', '' +
      '<div class="smw-rv__backdrop" data-rv-close></div>' +
      '<div class="smw-rv__panel" role="dialog" aria-modal="true" aria-label="View in a room">' +
      '  <div class="smw-rv__head"><div class="smw-rv__tabs" role="tablist">' +
      '    <button type="button" role="tab" data-rv-tab="room">View in a room</button>' +
      '    <button type="button" role="tab" data-rv-tab="ar">See it on your wall</button></div>' +
      '    <button type="button" class="smw-rv__x" data-rv-close aria-label="Close">&times;</button></div>' +
      '  <div class="smw-rv__body">' +
      '    <div class="smw-rv__room" data-rv-pane="room">' +
      '      <div class="smw-rv__stage"><div class="smw-rv__scene"><img class="smw-rv__bg" alt=""><div class="smw-rv__art"><div class="smw-rv__frame"></div><div class="smw-rv__pic"><img alt=""></div></div></div></div>' +
      '      <div class="smw-rv__rooms"></div>' +
      '    </div>' +
      '    <div class="smw-rv__ar" data-rv-pane="ar" hidden>' +
      '      <div class="smw-rv__mv"></div>' +
      '      <div class="smw-rv__qr" hidden><div class="smw-rv__qrcode"></div><p>Scan with your phone camera to see this print on your own wall, at its real size.</p></div>' +
      '      <p class="smw-rv__arnote"></p>' +
      '    </div>' +
      '    <div class="smw-rv__side">' +
      '      <p class="smw-rv__meta"></p>' +
      '      <div class="smw-rv__group" data-rv-mat-group><span class="smw-rv__lbl">Material</span><div class="smw-rv__chips" data-rv-mats></div></div>' +
      '      <div class="smw-rv__group"><span class="smw-rv__lbl">Size</span><div class="smw-rv__chips" data-rv-sizes></div></div>' +
      '      <div class="smw-rv__group"><span class="smw-rv__lbl">Frame</span><div class="smw-rv__chips" data-rv-frames></div></div>' +
      '      <div class="smw-rv__group" data-rv-border-group><span class="smw-rv__lbl">Border</span><div class="smw-rv__chips" data-rv-borders></div></div>' +
      '      <div class="smw-rv__buy"><span class="smw-rv__price"></span><button type="button" class="smw-rv__atc" data-rv-atc>Add to cart</button><p class="smw-rv__unavail" hidden></p></div>' +
      '      <p class="smw-rv__scale"></p>' +
      '    </div>' +
      '  </div></div>');
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-rv-close]')) return close();
      var tb = t.closest('[data-rv-tab]');
      if (tb) return setTab(tb.getAttribute('data-rv-tab'));
      var rm = t.closest('[data-rv-room]');
      if (rm) { roomIdx = +rm.getAttribute('data-rv-room'); return render(); }
      var sz = t.closest('[data-rv-size]');
      if (sz) return pickSize(sz.getAttribute('data-rv-size'));
      var fr = t.closest('[data-rv-frame]');
      if (fr) return pickFrame(fr.getAttribute('data-rv-frame'));
      var mt = t.closest('[data-rv-mat]');
      if (mt) return pickMaterial(mt.getAttribute('data-rv-mat'));
      var bd = t.closest('[data-rv-border]');
      if (bd) return pickBorder(bd.getAttribute('data-rv-border'));
      if (t.closest('[data-rv-atc]')) return addToCart();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) close(); });
  }

  function open(which) {
    if (!modal) build();
    modal.classList.add('is-open');
    document.documentElement.classList.add('smw-rv-lock');
    setTab(which || 'room');
  }
  function close() {
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('smw-rv-lock');
    var mv = q('model-viewer', modal);
    if (mv) mv.removeAttribute('src');
  }
  function setTab(t) {
    tab = t;
    qa('[data-rv-tab]', modal).forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-rv-tab') === t ? 'true' : 'false'); });
    qa('[data-rv-pane]', modal).forEach(function (p) { p.hidden = p.getAttribute('data-rv-pane') !== t; });
    modal.classList.toggle('is-ar', t === 'ar');
    render();
  }

  function chips(st) {
    var s = st.s;
    // Material: the page's own Fine Art Print / Canvas tiles (label.lbl-print / .lbl-canvas). Only offered when
    // both are on the page and visible (canvas-only products, or canvas hidden in this country, get no chips).
    var lp = q('.lbl-print', s), lc = q('.lbl-canvas', s), rc = q('#radio-canvas', s);
    var both = lp && lc && visible(lp) && visible(lc);
    q('[data-rv-mat-group]', modal).hidden = !both;
    if (both) {
      var onCanvas = !!(rc && rc.checked);
      q('[data-rv-mats]', modal).innerHTML =
        '<button type="button" data-rv-mat="print" aria-pressed="' + !onCanvas + '">Fine art print</button>' +
        '<button type="button" data-rv-mat="canvas" aria-pressed="' + onCanvas + '">Canvas</button>';
    }
    var sizes = sizeItems(s).map(function (li) {
      var k = li.getAttribute('data-title').trim();
      return '<button type="button" data-rv-size="' + k + '" aria-pressed="' + (k === st.key) + '">' + k.replace(/\s*x\s*/, '\u00d7').replace(/\s*cm$/, '') + '</button>';
    }).join('');
    q('[data-rv-sizes]', modal).innerHTML = sizes;
    var frames = qa('input[name="Frame"]', s).filter(function (i) {
      var w = i.closest('.variant-input') || i.parentNode;
      return visible(w);
    }).map(function (i) {
      var short = i.value.replace(' Floating Frame', '').replace(' Canvas', '').replace(' Frame', '');
      if (i.value === 'Stretched Canvas') short = 'Stretched';
      return '<button type="button" data-rv-frame="' + i.value.replace(/"/g, '&quot;') + '" aria-pressed="' + i.checked + '">' + short + '</button>';
    }).join('');
    q('[data-rv-frames]', modal).innerHTML = frames;
    // Border: the shopper-facing control is .fk-bcpo-radios (hidden in canvas mode - then no chips).
    var radios = qa('.fk-bcpo-radios input', s).filter(function (i) { return visible(i.closest('.fk-bcpo-radios') || i); });
    var white = /White/.test(st.border);
    q('[data-rv-border-group]', modal).hidden = !radios.length;
    q('[data-rv-borders]', modal).innerHTML = radios.map(function (i) {
      var on = /White/.test(i.value) === white;
      return '<button type="button" data-rv-border="' + i.value.replace(/"/g, '&quot;') + '" aria-pressed="' + on + '">' + (/White/.test(i.value) ? 'White border' : 'No border') + '</button>';
    }).join('');
    // Add to cart mirrors the page's real button, including the country rules' "Unavailable".
    var btn = atcBtn(s), price = q('[data-product-price]', s);
    var atc = q('[data-rv-atc]', modal), un = q('.smw-rv__unavail', modal);
    q('.smw-rv__price', modal).textContent = price ? price.textContent.replace(/\s+/g, ' ').trim() : '';
    var dis = atcDisabled(btn);
    atc.disabled = dis;
    var bt = btn && (q('[data-add-to-cart-text]', btn) || btn);
    atc.textContent = dis ? ((!UP && bt && bt.textContent.replace(/\s+/g, ' ').trim()) || 'Unavailable') : 'Add to cart';
    var note = q('.smw-ship-note', s);
    un.hidden = !(dis && note && note.style.display !== 'none');
    if (!un.hidden) un.textContent = note.textContent;
  }

  function pickMaterial(v) {
    var s = sec();
    var lab = q(v === 'canvas' ? '.lbl-canvas' : '.lbl-print', s);
    if (lab) lab.click();
    // the developer's switch swaps frames, hides sizes and moves the size, on its own timers
    setTimeout(render, 900);
    setTimeout(render, 1600);
  }
  function pickBorder(v) {
    var s = sec();
    var r = qa('.fk-bcpo-radios input', s).filter(function (i) { return i.value === v; })[0];
    if (r) { var lab = r.id && q('label[for="' + r.id + '"]', s); (lab || r).click(); }
    setTimeout(render, 650);
  }
  function addToCart() {
    var btn = atcBtn(sec());
    if (atcDisabled(btn)) return;
    close();
    btn.click();
  }

  function pickSize(k) {
    var st = readState();
    var li = sizeItems(st.s).filter(function (l) { return l.getAttribute('data-title').trim() === k; })[0];
    if (li) li.click();
    setTimeout(render, 450);
  }
  function pickFrame(v) {
    var s = sec();
    var inp = qa('input[name="Frame"]', s).filter(function (i) { return i.value === v; })[0];
    if (inp) {
      var lab = (inp.id && q('label[for="' + inp.id + '"]', s)) || (inp.closest('.variant-input') && q('label', inp.closest('.variant-input')));
      (lab || inp).click();
    }
    setTimeout(render, 650);
  }

  function render() {
    if (!modal || !modal.classList.contains('is-open')) return;
    var st = readState(), m = model(st);
    chips(st);
    var room = CFG.rooms[roomIdx] || CFG.rooms[0];
    q('.smw-rv__rooms', modal).innerHTML = CFG.rooms.map(function (r, i) {
      return '<button type="button" data-rv-room="' + i + '" aria-pressed="' + (i === roomIdx) + '"><img src="' + r.thumb + '" alt="" loading="lazy"><span>' + r.name + '</span></button>';
    }).join('');
    var meta = q('.smw-rv__meta', modal), scale = q('.smw-rv__scale', modal);
    if (!m) { meta.textContent = 'Choose a size to see it to scale.'; return; }
    meta.innerHTML = (/cm/.test(st.key) ? '' : '<strong>' + (st.key || '') + '</strong> &middot; ') + fmt(m.printW) + ' x ' + fmt(m.printH) + ' cm ' + (m.canvas ? 'canvas' : 'print') +
      (m.framed ? ' &middot; about ' + fmt(m.outerW) + ' x ' + fmt(m.outerH) + ' cm framed' : '') + '<br>' + st.frame + (m.framed || st.frame === 'Unframed' ? ' &middot; ' + st.border : '');
    if (tab === 'room') renderRoom(st, m, room, scale);
    else renderAR(st, m);
  }
  function fmt(n) { return (Math.round(n * 2) / 2).toString().replace(/\.0$/, ''); }

  function renderRoom(st, m, room, scale) {
    var stage = q('.smw-rv__stage', modal);
    var bg = q('.smw-rv__bg', stage);
    var want = window.innerWidth < 750 ? room.small : room.large;
    if (bg.getAttribute('src') !== want) bg.src = want;
    var hCm = room.widthCm / room.aspect;
    var centre = Math.max(room.minCentreCm, room.furnitureTopCm + room.clearCm + m.outerH / 2);
    centre = Math.min(centre, room.maxTopCm - m.outerH / 2);
    var art = q('.smw-rv__art', stage);
    art.style.width = (m.outerW / room.widthCm * 100) + '%';
    art.style.height = (m.outerH / hCm * 100) + '%';
    art.style.left = (50 + room.centreXCm / room.widthCm * 100 - m.outerW / room.widthCm * 50) + '%';
    art.style.top = (50 - (centre - room.horizonCm) / hCm * 100 - m.outerH / hCm * 50) + '%';
    // Phones show a closer crop of the scene (CSS: 4:3 stage, scene scaled about 50% 64%).
    // Zoom only as far as keeps the whole print in view, so B0 is never cut off.
    var scene = q('.smw-rv__scene', stage);
    if (window.innerWidth < 750) {
      var topF = parseFloat(art.style.top) / 100, botF = topF + parseFloat(art.style.height) / 100, oy = 0.64, z = 1.45;
      if (topF < oy) z = Math.min(z, (oy - 0.04) / (oy - topF));
      if (botF > oy) z = Math.min(z, (0.96 - oy) / (botF - oy));
      scene.style.transform = 'scale(' + Math.max(1, z).toFixed(3) + ')';
    } else scene.style.transform = '';
    art.className = 'smw-rv__art' + (m.canvas && !m.framed ? ' is-canvas' : '') + (m.framed ? ' is-framed' : '') + (m.paperBorder ? ' is-paper' : '');
    var frame = q('.smw-rv__frame', art);
    frame.style.backgroundImage = m.look.bg ? 'url("' + m.look.bg + '")' : '';
    frame.style.boxShadow = m.fallback ? 'inset 0 0 0 ' + (2.5 / room.widthCm * 100) + 'cqw ' + m.fallback : '';
    var pic = q('.smw-rv__pic', art), i = m.look.inset;
    pic.style.top = (i[0] * 100) + '%'; pic.style.right = (i[1] * 100) + '%'; pic.style.bottom = (i[2] * 100) + '%'; pic.style.left = (i[3] * 100) + '%';
    art.style.backgroundColor = m.look.gap || (m.paperBorder ? '#fbfaf7' : '');
    var pimg = q('img', pic);
    if (pimg.getAttribute('src') !== st.src) pimg.src = st.src;
    scale.textContent = 'Shown to scale next to ' + room.furniture + '.';
  }

  // ---------- AR ----------
  function loadImage(src) {
    return new Promise(function (res, rej) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); }; im.onerror = rej; im.src = src;
    });
  }
  function texture(st, m) {
    var long = 1400, W, H;
    if (m.outerW >= m.outerH) { W = long; H = Math.round(long * m.outerH / m.outerW); } else { H = long; W = Math.round(long * m.outerW / m.outerH); }
    return Promise.all([loadImage(st.src), m.look.bg ? loadImage(m.look.bg).catch(function () { return null; }) : null]).then(function (ims) {
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var g = c.getContext('2d');
      g.fillStyle = m.look.gap || (m.paperBorder ? '#fbfaf7' : '#ffffff'); g.fillRect(0, 0, W, H);
      var i = m.look.inset, x = i[3] * W, y = i[0] * H, w = W - x - i[1] * W, h = H - y - i[2] * H;
      var a = ims[0], s = Math.max(w / a.naturalWidth, h / a.naturalHeight), sw = w / s, sh = h / s;
      g.drawImage(a, (a.naturalWidth - sw) / 2, (a.naturalHeight - sh) / 2, sw, sh, x, y, w, h);
      if (ims[1]) g.drawImage(ims[1], 0, 0, W, H);
      else if (m.fallback) { g.strokeStyle = m.fallback; g.lineWidth = 2 * 2.5 / m.outerW * W; g.strokeRect(0, 0, W, H); }
      return new Promise(function (res) { c.toBlob(function (b) { b.arrayBuffer().then(function (ab) { res({ bytes: new Uint8Array(ab), edge: edgeColour(g, W, H, m) }); }); }, 'image/jpeg', 0.9); });
    });
  }
  function edgeColour(g, W, H, m) {
    if (!m.framed && !m.canvas) return [0.92, 0.92, 0.9];
    var d = g.getImageData(Math.round(W / 2), 1, 1, 1).data;
    return [d[0], d[1], d[2]].map(function (v) { v /= 255; return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
  }
  // Minimal GLB: a box, front face textured (+Z faces out of the wall), other faces one colour.
  function glb(wM, hM, dM, jpg, edge) {
    var x = wM / 2, y = hM / 2, z = dM, P = [], N = [], U = [];
    function face(v, n, uv) { for (var k = 0; k < 4; k++) { P.push.apply(P, v[k]); N.push.apply(N, n); U.push.apply(U, uv ? uv[k] : [0, 0]); } }
    face([[-x, -y, z], [x, -y, z], [x, y, z], [-x, y, z]], [0, 0, 1], [[0, 1], [1, 1], [1, 0], [0, 0]]);
    face([[x, -y, 0], [-x, -y, 0], [-x, y, 0], [x, y, 0]], [0, 0, -1]);
    face([[x, -y, z], [x, -y, 0], [x, y, 0], [x, y, z]], [1, 0, 0]);
    face([[-x, -y, 0], [-x, -y, z], [-x, y, z], [-x, y, 0]], [-1, 0, 0]);
    face([[-x, y, z], [x, y, z], [x, y, 0], [-x, y, 0]], [0, 1, 0]);
    face([[-x, -y, 0], [x, -y, 0], [x, -y, z], [-x, -y, z]], [0, -1, 0]);
    var i0 = [0, 1, 2, 0, 2, 3], i1 = [];
    for (var f = 1; f < 6; f++) { var b = f * 4; i1.push(b, b + 1, b + 2, b, b + 2, b + 3); }
    var parts = [new Float32Array(P), new Float32Array(N), new Float32Array(U), new Uint16Array(i0), new Uint16Array(i1), jpg];
    var views = [], off = 0, chunks = [];
    parts.forEach(function (p, k) {
      var bytes = new Uint8Array(p.buffer, p.byteOffset, p.byteLength);
      var v = { buffer: 0, byteOffset: off, byteLength: bytes.length };
      if (k < 3) v.target = 34962; else if (k < 5) v.target = 34963;
      views.push(v); chunks.push(bytes);
      var pad = (4 - (bytes.length % 4)) % 4; off += bytes.length + pad;
      if (pad) chunks.push(new Uint8Array(pad));
    });
    var json = {
      asset: { version: '2.0', generator: 'stylemywall room view' }, scene: 0, scenes: [{ nodes: [0] }], nodes: [{ mesh: 0 }],
      meshes: [{ primitives: [
        { attributes: { POSITION: 0, NORMAL: 1, TEXCOORD_0: 2 }, indices: 3, material: 0 },
        { attributes: { POSITION: 0, NORMAL: 1, TEXCOORD_0: 2 }, indices: 4, material: 1 }] }],
      materials: [
        { pbrMetallicRoughness: { baseColorTexture: { index: 0 }, metallicFactor: 0, roughnessFactor: 0.75 } },
        { pbrMetallicRoughness: { baseColorFactor: [edge[0], edge[1], edge[2], 1], metallicFactor: 0, roughnessFactor: 0.8 } }],
      textures: [{ source: 0, sampler: 0 }], samplers: [{ magFilter: 9729, minFilter: 9987, wrapS: 33071, wrapT: 33071 }],
      images: [{ bufferView: 5, mimeType: 'image/jpeg' }],
      accessors: [
        { bufferView: 0, componentType: 5126, count: 24, type: 'VEC3', min: [-x, -y, 0], max: [x, y, z] },
        { bufferView: 1, componentType: 5126, count: 24, type: 'VEC3' },
        { bufferView: 2, componentType: 5126, count: 24, type: 'VEC2' },
        { bufferView: 3, componentType: 5123, count: 6, type: 'SCALAR' },
        { bufferView: 4, componentType: 5123, count: 30, type: 'SCALAR' }],
      bufferViews: views, buffers: [{ byteLength: off }]
    };
    var js = new TextEncoder().encode(JSON.stringify(json));
    var jpad = (4 - (js.length % 4)) % 4, jsonLen = js.length + jpad;
    var total = 12 + 8 + jsonLen + 8 + off, out = new Uint8Array(total), dv = new DataView(out.buffer);
    dv.setUint32(0, 0x46546C67, true); dv.setUint32(4, 2, true); dv.setUint32(8, total, true);
    dv.setUint32(12, jsonLen, true); dv.setUint32(16, 0x4E4F534A, true); out.set(js, 20);
    for (var j = 0; j < jpad; j++) out[20 + js.length + j] = 0x20;
    var p0 = 20 + jsonLen; dv.setUint32(p0, off, true); dv.setUint32(p0 + 4, 0x004E4942, true);
    var pos = p0 + 8; chunks.forEach(function (c) { out.set(c, pos); pos += c.length; });
    return out;
  }
  window.__smwRoomViewGlb = glb; // exposed for testing

  // iPhone: model-viewer's own USDZ export anchors to FLOORS, so the Quick Look file is built
  // here with vertical (wall) anchoring. Quick Look treats +Y as OUT of the wall (owner's iPhone test 2026-10-03:
  // a +Z-front model lay flat, face down), so the default maps front -> +Y and up -> -Z. ?rv_ios=z = the old
  // +Z-front layout, ?rv_ios=flip = the default turned 180 degrees (if a phone ever shows it upside down). Old note:
  // ?rv_ios=y switched to the
  // ARKit plane-anchor convention (+Y out of the wall) in case Quick Look reads it that way.
  var CRC = (function () { var t = []; for (var n = 0; n < 256; n++) { var c = n; for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1; t[n] = c >>> 0; } return t; })();
  function crc32(b) { var c = 0xFFFFFFFF; for (var i = 0; i < b.length; i++) c = CRC[(c ^ b[i]) & 255] ^ (c >>> 8); return (c ^ 0xFFFFFFFF) >>> 0; }
  function zipStore(files) { // files: [{name, data:Uint8Array}], data 64-byte aligned (USDZ rule)
    var parts = [], central = [], off = 0, enc = new TextEncoder();
    files.forEach(function (f) {
      var name = enc.encode(f.name), crc = crc32(f.data), base = off + 30 + name.length, pad = (64 - ((base + 4) % 64)) % 64;
      var extra = new Uint8Array(4 + pad); var ev = new DataView(extra.buffer); ev.setUint16(0, 0x1986, true); ev.setUint16(2, pad, true);
      var h = new Uint8Array(30), d = new DataView(h.buffer);
      d.setUint32(0, 0x04034b50, true); d.setUint16(4, 20, true); d.setUint16(6, 0, true); d.setUint16(8, 0, true);
      d.setUint32(14, crc, true); d.setUint32(18, f.data.length, true); d.setUint32(22, f.data.length, true);
      d.setUint16(26, name.length, true); d.setUint16(28, extra.length, true);
      parts.push(h, name, extra, f.data);
      var c = new Uint8Array(46), cd = new DataView(c.buffer);
      cd.setUint32(0, 0x02014b50, true); cd.setUint16(4, 20, true); cd.setUint16(6, 20, true);
      cd.setUint32(16, crc, true); cd.setUint32(20, f.data.length, true); cd.setUint32(24, f.data.length, true);
      cd.setUint16(28, name.length, true); cd.setUint32(42, off, true);
      central.push(c, name);
      off += 30 + name.length + extra.length + f.data.length;
    });
    var cdSize = central.reduce(function (a, b) { return a + b.length; }, 0);
    var e = new Uint8Array(22), ed = new DataView(e.buffer);
    ed.setUint32(0, 0x06054b50, true); ed.setUint16(8, files.length, true); ed.setUint16(10, files.length, true);
    ed.setUint32(12, cdSize, true); ed.setUint32(16, off, true);
    var all = parts.concat(central, [e]), total = all.reduce(function (a, b) { return a + b.length; }, 0), out = new Uint8Array(total), p = 0;
    all.forEach(function (b) { out.set(b, p); p += b.length; });
    return out;
  }
  function usdz(wM, hM, dM, jpg, edge, mode) {
    var x = wM / 2, y = hM / 2, z = dM;
    function T(v) { return mode === 'z' ? v : mode === 'flip' ? [-v[0], v[2], v[1]] : [v[0], v[2], -v[1]]; }
    function pts(a) { return '[' + a.map(function (v) { v = T(v); return '(' + v.map(function (n) { return +n.toFixed(5); }).join(', ') + ')'; }).join(', ') + ']'; }
    var front = [[-x, -y, z], [x, -y, z], [x, y, z], [-x, y, z]];
    var sides = [[x, -y, 0], [-x, -y, 0], [-x, y, 0], [x, y, 0], [x, -y, z], [x, -y, 0], [x, y, 0], [x, y, z],
      [-x, -y, 0], [-x, -y, z], [-x, y, z], [-x, y, 0], [-x, y, z], [x, y, z], [x, y, 0], [-x, y, 0],
      [-x, -y, 0], [x, -y, 0], [x, -y, z], [-x, -y, z]];
    var nf = T([0, 0, 1]);
    var col = '(' + edge.map(function (n) { return n.toFixed(4); }).join(', ') + ')';
    var usda = '#usda 1.0\n(\n    customLayerData = {\n        string creator = "Style My Wall room view"\n    }\n    defaultPrim = "Root"\n    metersPerUnit = 1\n    upAxis = "Y"\n)\n\n' +
      'def Xform "Root"\n{\n    def Scope "Scenes" (\n        kind = "sceneLibrary"\n    )\n    {\n' +
      '        def Xform "Scene" (\n            customData = {\n                bool preliminary_collidesWithEnvironment = 0\n                string sceneName = "Scene"\n            }\n            sceneName = "Scene"\n        )\n        {\n' +
      '            token preliminary:anchoring:type = "plane"\n            token preliminary:planeAnchoring:alignment = "vertical"\n\n' +
      '            def Mesh "Front" (\n                prepend apiSchemas = ["MaterialBindingAPI"]\n            )\n            {\n                int[] faceVertexCounts = [4]\n                int[] faceVertexIndices = [0, 1, 2, 3]\n' +
      '                rel material:binding = </Root/Materials/Art>\n                normal3f[] normals = [(' + nf.join(', ') + '), (' + nf.join(', ') + '), (' + nf.join(', ') + '), (' + nf.join(', ') + ')] (\n                    interpolation = "vertex"\n                )\n' +
      '                point3f[] points = ' + pts(front) + '\n                texCoord2f[] primvars:st = [(0, 0), (1, 0), (1, 1), (0, 1)] (\n                    interpolation = "vertex"\n                )\n                uniform token subdivisionScheme = "none"\n            }\n' +
      '            def Mesh "Sides" (\n                prepend apiSchemas = ["MaterialBindingAPI"]\n            )\n            {\n                int[] faceVertexCounts = [4, 4, 4, 4, 4]\n                int[] faceVertexIndices = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]\n' +
      '                rel material:binding = </Root/Materials/Edge>\n                point3f[] points = ' + pts(sides) + '\n                uniform token subdivisionScheme = "none"\n            }\n        }\n    }\n\n' +
      '    def Scope "Materials"\n    {\n        def Material "Art"\n        {\n            token outputs:surface.connect = </Root/Materials/Art/Surface.outputs:surface>\n\n' +
      '            def Shader "Surface"\n            {\n                uniform token info:id = "UsdPreviewSurface"\n                color3f inputs:diffuseColor.connect = </Root/Materials/Art/Tex.outputs:rgb>\n                float inputs:metallic = 0\n                float inputs:roughness = 0.75\n                token outputs:surface\n            }\n\n' +
      '            def Shader "Reader"\n            {\n                uniform token info:id = "UsdPrimvarReader_float2"\n                string inputs:varname = "st"\n                float2 outputs:result\n            }\n\n' +
      '            def Shader "Tex"\n            {\n                uniform token info:id = "UsdUVTexture"\n                asset inputs:file = @textures/art.jpg@\n                float2 inputs:st.connect = </Root/Materials/Art/Reader.outputs:result>\n                token inputs:wrapS = "clamp"\n                token inputs:wrapT = "clamp"\n                float3 outputs:rgb\n            }\n        }\n\n' +
      '        def Material "Edge"\n        {\n            token outputs:surface.connect = </Root/Materials/Edge/Surface.outputs:surface>\n\n' +
      '            def Shader "Surface"\n            {\n                uniform token info:id = "UsdPreviewSurface"\n                color3f inputs:diffuseColor = ' + col + '\n                float inputs:metallic = 0\n                float inputs:roughness = 0.8\n                token outputs:surface\n            }\n        }\n    }\n}\n';
    return zipStore([{ name: 'model.usda', data: new TextEncoder().encode(usda) }, { name: 'textures/art.jpg', data: jpg }]);
  }
  window.__smwRoomViewUsdz = usdz; // exposed for testing

  function loadMV() {
    if (window.customElements && customElements.get('model-viewer')) return Promise.resolve();
    if (!mvLoading) mvLoading = new Promise(function (res, rej) {
      var s = document.createElement('script'); s.type = 'module'; s.src = CFG.modelViewer;
      s.onerror = rej; document.head.appendChild(s);
      customElements.whenDefined('model-viewer').then(res);
    });
    return mvLoading;
  }
  function loadQR() {
    if (window.QRCode) return Promise.resolve();
    return new Promise(function (res, rej) { var s = document.createElement('script'); s.src = CFG.qr; s.onload = res; s.onerror = rej; document.head.appendChild(s); });
  }
  function isTouchPhone() { return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); }

  function renderAR(st, m) {
    var note = q('.smw-rv__arnote', modal), box = q('.smw-rv__mv', modal), qr = q('.smw-rv__qr', modal);
    var scale = q('.smw-rv__scale', modal);
    scale.textContent = '';
    if (!isTouchPhone() && UP) {
      box.hidden = true; qr.hidden = false; note.textContent = '';
      var cq = q('.smw-rv__qrcode', modal);
      cq.innerHTML = ''; cq.style.display = 'none';
      q('.smw-rv__qr p', modal).textContent = 'See it on your wall works on your phone: open Upload Your Own on your phone, upload your photo there and tap "On your wall". It places your print on your real wall at its true size.';
      return;
    }
    if (!isTouchPhone()) {
      box.hidden = true; qr.hidden = false; note.textContent = '';
      q('.smw-rv__qrcode', modal).style.display = '';
      q('.smw-rv__qr p', modal).textContent = 'Scan with your phone camera to see this print on your own wall, at its real size.';
      var pv = window.Shopify && Shopify.theme && Shopify.theme.role !== 'main' ? 'preview_theme_id=' + Shopify.theme.id + '&' : '';
      var url = location.origin + location.pathname + '?' + pv + 'smw_ar=1&rv_s=' + encodeURIComponent(st.key) + '&rv_f=' + encodeURIComponent(st.frame) + '&rv_b=' + encodeURIComponent(st.border);
      loadQR().then(function () {
        var c = q('.smw-rv__qrcode', modal); c.innerHTML = '';
        new window.QRCode(c, { text: url, width: 200, height: 200, correctLevel: window.QRCode.CorrectLevel.M });
      }).catch(function () { q('.smw-rv__qrcode', modal).textContent = url; });
      return;
    }
    box.hidden = false; qr.hidden = true;
    note.textContent = 'Preparing your print...';
    var token = {}; renderAR.token = token;
    Promise.all([loadMV(), texture(st, m)]).then(function (r) {
      if (renderAR.token !== token) return;
      var t = r[1];
      var bytes = glb(m.outerW / 100, m.outerH / 100, m.depth / 100, t.bytes, t.edge);
      if (lastGlbUrl) URL.revokeObjectURL(lastGlbUrl);
      if (lastUsdzUrl) URL.revokeObjectURL(lastUsdzUrl);
      lastGlbUrl = URL.createObjectURL(new Blob([bytes], { type: 'model/gltf-binary' }));
      var iosMode = START.get('rv_ios') || 'y';
      lastUsdzUrl = URL.createObjectURL(new Blob([usdz(m.outerW / 100, m.outerH / 100, m.depth / 100, t.bytes, t.edge, iosMode)], { type: 'model/vnd.usdz+zip' }));
      var mv = q('model-viewer', box);
      if (!mv) {
        mv = document.createElement('model-viewer');
        mv.setAttribute('ar', ''); mv.setAttribute('ar-modes', 'webxr quick-look');
        mv.setAttribute('ar-placement', 'wall'); mv.setAttribute('ar-scale', 'fixed');
        mv.setAttribute('camera-controls', ''); mv.setAttribute('touch-action', 'pan-y');
        mv.setAttribute('shadow-intensity', '0.6'); mv.setAttribute('exposure', '1.05');
        mv.setAttribute('alt', 'This print in 3D');
        mv.innerHTML = '<button slot="ar-button" class="smw-rv__arbtn" type="button"><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8.5A1.5 1.5 0 0 1 4.5 7h2.6l1.6-2.2h6.6L16.9 7h2.6A1.5 1.5 0 0 1 21 8.5v9A1.5 1.5 0 0 1 19.5 19h-15A1.5 1.5 0 0 1 3 17.5z"/><circle cx="12" cy="12.8" r="3.4"/></svg>View on your wall</button>';
        box.appendChild(mv);
        mv.addEventListener('load', function () {
          note.textContent = mv.canActivateAR ? ''
            : 'Your browser cannot open the camera view. Try Safari on iPhone or Chrome on Android.';
        });
        mv.addEventListener('ar-status', function (e) { if (e.detail.status === 'failed') note.textContent = 'The camera view could not start on this device.'; });
      }
      mv.setAttribute('ios-src', lastUsdzUrl);
      mv.setAttribute('src', lastGlbUrl);
    }).catch(function () { note.textContent = 'The 3D view could not load. Please try again.'; });
  }

  // ---------- QR landing: apply the desktop selection, then open the AR tab ----------
  function applyFromUrl() {
    var p = START;
    if (p.get('smw_ar') !== '1') return;
    var s = sec(); if (!s) return;
    var f = p.get('rv_f') || '', k = p.get('rv_s') || '', b = p.get('rv_b') || '';
    var steps = [];
    if (/Canvas|Leaf/.test(f)) steps.push(function () { var c = q('.lbl-canvas', s); var r = q('#radio-canvas', s); if (c && !(r && r.checked)) c.click(); });
    steps.push(function () { var li = sizeItems(s).filter(function (l) { return l.getAttribute('data-title').trim() === k; })[0]; if (li) li.click(); });
    steps.push(function () { if (f) pickFrame(f); });
    steps.push(function () { if (!b) return; var r = qa('.fk-bcpo-radios input', s).filter(function (i) { return b.indexOf(i.value) > -1 || i.value.indexOf(b) > -1; })[0]; if (r && !r.checked) r.click(); });
    var n = 0;
    (function next() { if (n < steps.length) { try { steps[n++](); } catch (e) {} setTimeout(next, 600); } else open('ar'); })();
  }

  if (UP) {
    var row = q('.smw-rv-row'), lfp = q('.left-frame-preview');
    if (row && lfp) {
      lfp.parentNode.insertBefore(row, lfp.nextSibling);
      var sync = function () { var want = !upReady(); if (row.hidden !== want) row.hidden = want; };
      sync();
      // watches the preview only; the row lives outside it, so its own write cannot re-trigger this
      new MutationObserver(sync).observe(upFrameEl(), { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
      document.addEventListener('click', function () { setTimeout(sync, 300); }, true);
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-smw-rv-open]');
    if (!b) return;
    e.preventDefault();
    open(b.getAttribute('data-smw-rv-open'));
  });
  if (document.readyState === 'complete') setTimeout(applyFromUrl, 800);
  else window.addEventListener('load', function () { setTimeout(applyFromUrl, 800); });
})();
